import SplitWithImageV2 from './SplitWithImageV2'
export default SplitWithImageV2
